
















import { Component, Vue, Prop } from 'vue-property-decorator'
import Incrementer from './BaseIncrementer.vue'
import Badge from './BaseBadge.vue'
import Thumb from './BaseSkuThumb.vue'
import ItemSkeleton from './cart/CartItemSkeleton.vue'

@Component({
  components: { Incrementer, ItemSkeleton, Badge, Thumb },
})
export default class ItemListItem extends Vue {
  @Prop() sku!: string
  @Prop() quantity!: number
  @Prop() title!: string
  @Prop() icon!: string
  @Prop() clothingType!: string
  @Prop() cost!: number
  @Prop() color!: string
  @Prop({ type: Boolean, default: false }) closeout: boolean
  @Prop({ type: Boolean, default: false }) inverse: boolean

  @Prop() fetching: boolean

  async incrementItemQuantity (amount: number) {
    this.$emit('increment', { amount, sku: this.sku })
  }

  async removeAll () {
    this.$emit('increment', { amount: 0, sku: this.sku })
  }
}
